import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor, actionPatient } from "../../redux/actions";
import { DashboardCommonPage } from "../../commonPage";
import { FaArrowTrendUp } from "react-icons/fa6";
import { Col, Row } from "react-bootstrap";
import { Badges, Buttton, Modaal, Tabbles } from "../../components";
import {
    PiStethoscope,
    PiTrash,
    PiThumbsUp,
    PiCalendar,
    PiFolderOpen,
} from "react-icons/pi";
import { FiPhoneCall } from "react-icons/fi";
import { Link, useNavigate } from "react-router-dom";
import { FaCaretRight } from "react-icons/fa";
import { useAlert, useToast } from "../../contexts";
import { Commons } from "../../utilities";
import { LuFileSearch2, LuMessagesSquare } from "react-icons/lu";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";

const Dashboard = ({ loginData }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const { showToast } = useToast();
    const [showModal1, setShowModal1] = useState(false);
    const [showModal2, setShowModal2] = useState(false);
    const [showModal3, setShowModal3] = useState(false);
    const [showModal4, setShowModal4] = useState(false);
    const [showModal5, setShowModal5] = useState(false);
    const [selectedAppointmentGuid, setSelectedAppointmentGuid] = useState(null);
    const [credentials] = useState({
        doctorGuid: loginData.userGuid,
        currency: loginData?.currencyCode,
    });
    const handleCloseModal = () => {
        setShowModal1(false);
    };

    const today = new Date();
    const formattedDate = Commons.formatDateWithOrdinal(today);
    useEffect(() => {
        dispatch(actionDoctor.getDashBoardByDoctorId(loginData.userGuid, null));
        dispatch(actionDoctor.getAllDoctorClinicRequests(loginData.userGuid, null));
        dispatch(
            actionDoctor.getChatAppointmentByDoctor({
                doctorGuid: loginData.userGuid,
                currency: loginData?.currencyCode,
                languageId: loginData?.languageId,
                RequestTimeZone: loginData.timeZoneId,
            })
        );
        dispatch(
            actionPatient.getAppointments(
                10,
                1,
                "",
                "",
                "",
                "",
                loginData.userGuid,
                2,
                "",
                "",
                null,
                null,
                loginData?.currencyCode,
                loginData.timeZoneId,
                null,
                null,
                null,
                loginData?.languageId,
                [1, 2, 3],
                null
            )
        );

        dispatch(
            actionPatient.getClinicUpcomingAppointments(
                10,
                1,
                "",
                "",
                "",
                "",
                null,
                2,
                "",
                "",
                null,
                null,
                loginData?.currencyCode,
                loginData.timeZoneId,
                loginData.clinicGuid,
                null,
                null,
                loginData?.languageId,
                [1, 2, 3]
            )
        );

        dispatch(
            actionPatient.getRequestedAppointments(
                10,
                1,
                "",
                "",
                "",
                "",
                loginData.userGuid,
                1,
                "",
                "",
                null,
                null,
                loginData?.currencyCode,
                loginData.timeZoneId,
                null,
                null,
                null,
                loginData?.languageId,
                [1, 2, 3]
            )
        );

        dispatch(
            actionPatient.getClinicRequestedAppointments(
                10,
                1,
                "",
                "",
                "",
                "",
                null,
                1,
                "",
                "",
                null,
                null,
                loginData?.currencyCode,
                loginData.timeZoneId,
                loginData.clinicGuid,
                null,
                null,
                loginData?.languageId,
                [1, 2, 3]
            )
        );
    }, [dispatch, loginData]);
    useEffect(() => {
        dispatch(actionDoctor.getEmergencyCallByDoctor(credentials));
    }, [dispatch, credentials]);

    const getDashboardByDoctorIdData = useSelector(
        (state) => state.doctor.getDashboardByDoctorIdData?.data
    );
    const getAllDoctorClinicRequestsData = useSelector(
        (state) => state.doctor.getAllDoctorClinicRequestsData?.data?.result
    );
    const getChatAppointmentByDoctorData = useSelector(
        (state) => state.doctor.getChatAppointmentByDoctorData?.data
    );
    const getAppointmentsData = useSelector(
        (state) => state.patient.getAppointmentsData?.data
    );
    const getClinicUpcomingAppointmentsData = useSelector(
        (state) => state.patient.getClinicUpcomingAppointmentsData?.data
    );
    const getRequestedAppointmentsData = useSelector(
        (state) => state.patient.getRequestedAppointmentsData?.data
    );
    const getClinicRequestedAppointmentsData = useSelector(
        (state) => state.patient.getClinicRequestedAppointmentsData?.data
    );
    const getEmergencyCallByDoctorData = useSelector(
        (state) => state.doctor.getEmergencyCallByDoctorData?.data
    );

    const chatRequest = (
        getAllDoctorClinicRequestsData?.filter((item) => item.status === 1) || []
    ).sort((a, b) => new Date(a.date) - new Date(b.date));

    const overView = [
        {
            header: t("doctor.dashboard.total_earning"),
            title: getDashboardByDoctorIdData?.result.totalAmount || 0,
            content: (
                <div className="cardd-body-text">
                    <p className="exado-title-ten">+11.02%</p>
                    <FaArrowTrendUp className="card-icn" />
                </div>
            ),
            to: "/doctor/my-finances",
        },
        {
            header: t("doctor.dashboard.total_appointment"),
            title: getDashboardByDoctorIdData?.result.totalAppoinment || 0,
            content: (
                <div className="cardd-body-text">
                    <p className="exado-title-ten">+11.02%</p>
                    <FaArrowTrendUp className="card-icn" />
                </div>
            ),
            to: "/doctor/appointment-completed/my-appointments",
        },
        {
            header: t("doctor.dashboard.total_patients"),
            title: getDashboardByDoctorIdData?.result.totalPatient || 0,
            content: (
                <div className="cardd-body-text">
                    <p className="exado-title-ten">+11.02%</p>
                    <FaArrowTrendUp className="card-icn" />
                </div>
            ),
            to: "/doctor/my-patients",
        },
        {
            header: t("doctor.dashboard.total_consultancy_hr"),
            title: getDashboardByDoctorIdData?.result.totalConsultHour || 0,
            content: (
                <div className="cardd-body-text">
                    <p className="exado-title-ten">+11.02%</p>
                    <FaArrowTrendUp className="card-icn" />
                </div>
            ),
        },
    ];
    const handleAcceptReject = (appointment, isConfirm) => {
        dispatch(
            actionPatient.postAppointmentStatus(
                appointment?.appointmentGuid,
                isConfirm,
                (error, response) => {
                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.error && error.data.error.ValidationErrors) {
                                    error.data.error.ValidationErrors.forEach(
                                        (validationError) => {
                                            console.error(
                                                `${t("Field")}: ${validationError.Field} - ${t(
                                                    "Message"
                                                )}: ${validationError.Message}`
                                            );

                                            showAlert(
                                                "danger",
                                                validationError.Message,
                                                `${t("Error")} : ${validationError.Field}`
                                            );
                                        }
                                    );
                                } else {
                                    showAlert(
                                        "danger",
                                        t("Invalid_credentials"),
                                        `${t("Error")} !`
                                    );
                                }
                            } else {
                                showAlert("danger", t("unexpected_error"), `${t("Error")} !`);
                            }
                        }
                    } else if (response) {
                        if (response.status === 200) {
                            if (isConfirm) {
                                showToast(
                                    t("success"),
                                    t("doctor.dashboard.appointment_accepted"),
                                    5000,
                                    true,
                                    "top-end toast-success"
                                );
                                dispatch(
                                    actionPatient.getRequestedAppointments(
                                        10,
                                        1,
                                        "",
                                        "",
                                        "",
                                        "",
                                        loginData.userGuid,
                                        1,
                                        "",
                                        "",
                                        null,
                                        null,
                                        loginData?.currencyCode,
                                        loginData.timeZoneId,
                                        null,
                                        null,
                                        null,
                                        loginData?.languageId,
                                        [1, 2, 3]
                                    )
                                );
                            } else {
                                showToast(
                                    t("Rejected"),
                                    t("doctor.dashboard.appointment_rejected"),
                                    5000,
                                    true,
                                    "top-end toast-Danger"
                                );
                                dispatch(
                                    actionPatient.getRequestedAppointments(
                                        10,
                                        1,
                                        "",
                                        "",
                                        "",
                                        "",
                                        loginData.userGuid,
                                        1,
                                        "",
                                        "",
                                        null,
                                        null,
                                        loginData?.currencyCode,
                                        loginData.timeZoneId,
                                        null,
                                        null,
                                        null,
                                        loginData?.languageId,
                                        [1, 2, 3]
                                    )
                                );
                            }
                        }
                    }
                }
            )
        );
    };
    const handleRequest = (request, status) => {
        let credentials = {
            doctorClinicRequestGuid: request.doctorClinicRequestGuid,
            DoctorGuid: loginData.userGuid,
            clinicGuid: request.clinicGuid,
            status: status,
        };

        dispatch(
            actionDoctor.postSendDoctorClinicRequest(
                credentials,
                (error, response) => {
                    if (error) {
                        if (error.data) {
                            if (error.data.statusCode === 400) {
                                if (error.data.message) {
                                    showAlert("danger", error.data.message, `${t("Error")} : `);
                                } else {
                                    if (error.data.error && error.data.error.ValidationErrors) {
                                        error.data.error.ValidationErrors.forEach(
                                            (validationError) => {
                                                console.error(
                                                    `${t("Field")}: ${validationError.Field} - ${t(
                                                        "Message"
                                                    )}: ${validationError.Message}`
                                                );

                                                showAlert(
                                                    "danger",
                                                    validationError.Message,
                                                    `${t("Error")} : ${validationError.Field}`
                                                );
                                            }
                                        );
                                    } else {
                                        showAlert(
                                            "danger",
                                            `${t("Invalid_credentials")}`,
                                            `${t("Error")} !`
                                        );
                                    }
                                }
                            } else {
                                showAlert(
                                    "danger",
                                    `${t("unexpected_error")}``${t("Error")} !`
                                );
                            }
                        }
                    } else if (response) {
                        let successMessage =
                            status === 2
                                ? t("doctor.dashboard.doctor_added")
                                : t("doctor.dashboard.doctor_rejected");
                        if (response.status === 200) {
                            showToast(
                                t("success"),
                                successMessage,
                                5000,
                                true,
                                "top-end toast-success"
                            );
                            dispatch(
                                actionDoctor.getAllDoctorClinicRequests(
                                    loginData.userGuid,
                                    null
                                )
                            );
                        }
                    }
                }
            )
        );
    };

    const handleVideoCall = (appointment) => {
        dispatch(actionDoctor.postUpdateEmergencyCall(
            {
                appointmentGuid: appointment?.appointmentGuid,
                doctorGuid: loginData?.userGuid,
                status: 2,
                attend: true
            },
            (error, response) => {
                if (error) {
                    if (error.data) {
                        if (error.data.statusCode === 400) {
                            if (error.data.message) {
                                showAlert("danger", error.data.message, `${t("Error")} : `);
                            } else {
                                if (error.data.error && error.data.error.ValidationErrors) {
                                    error.data.error.ValidationErrors.forEach(
                                        (validationError) => {
                                            console.error(
                                                `${t("Field")}: ${validationError.Field} - ${t(
                                                    "Message"
                                                )}: ${validationError.Message}`
                                            );

                                            showAlert(
                                                "danger",
                                                validationError.Message,
                                                `${t("Error")} : ${validationError.Field}`
                                            );
                                        }
                                    );
                                } else {
                                    showAlert(
                                        "danger",
                                        `${t("Invalid_credentials")}`,
                                        `${t("Error")} !`
                                    );
                                }
                            }
                        } else {
                            showAlert(
                                "danger",
                                `${t("unexpected_error")}``${t("Error")} !`
                            );
                        }
                    }
                } else if (response) {
                    if (response.status === 200) {
                        showToast(
                            t("success"),
                            "",
                            5000,
                            true,
                            "top-end toast-success"
                        );
                        navigate(`/doctor/conference-room/${appointment?.appointmentGuid}`, {
                            state: {
                                appointment,
                            },
                        })
                    }
                }
            }))
    }

    const postBookedAppointment = (
        appointment,
        openModal,
        chatAppointmentDetails,
        emergencyCall
    ) => {
        const credentials = {
            UserTimeZone: loginData.timeZoneId,
            UserCurrency: loginData?.currencyCode,
            appointmentGuid: appointment.appointmentGuid,
            LanguageId: loginData.languageId,
        };

        if (emergencyCall) {
            dispatch(actionDoctor.postBookedEmergencyAppointment(credentials))
            setShowModal5(true)

        } else if (chatAppointmentDetails) {
            dispatch(
                actionPatient.getBookedChatDetails(credentials, (error, response) => {
                    if (error) {
                        if (error.data?.statusCode === 400) {
                            const validationErrors = error.data.error?.ValidationErrors || [];
                            validationErrors.forEach((validationError) => {
                                console.error(
                                    `${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message
                                    }`
                                );
                                showAlert(
                                    "danger",
                                    validationError.Message,
                                    `${t("Error")} : ${validationError.Field}`
                                );
                            });
                        } else {
                            showAlert("danger", t("Invalid_credentials"), `${t("Error")} !`);
                        }
                    } else if (response?.status === 200) {
                        setShowModal4(true);
                    }
                })
            );
        } else {
            dispatch(
                actionPatient.postBookedAppointment(credentials, (error, response) => {
                    if (error) {
                        if (error.data?.statusCode === 400) {
                            const validationErrors = error.data.error?.ValidationErrors || [];
                            validationErrors.forEach((validationError) => {
                                console.error(
                                    `${t("Field")}: ${validationError.Field} - ${t("Message")}: ${validationError.Message
                                    }`
                                );
                                showAlert(
                                    "danger",
                                    validationError.Message,
                                    `${t("Error")} : ${validationError.Field}`
                                );
                            });
                        } else {
                            showAlert("danger", t("Invalid_credentials"), `${t("Error")} !`);
                        }
                    } else if (response?.status === 200) {
                        if (openModal) {
                            setShowModal2(true);
                        }
                    }
                })
            );
        }
    };

    const filteredCalls = getEmergencyCallByDoctorData?.result?.filter(
        (call) => call.status === 1
    );

    const rightSide1 = (
        <>
            <Row className="exado-row1">
                <Col md={8}>
                    <h2 className="exado-title-nine">{t("appointments.appointments")}</h2>
                    <p className="exado-title-three ">{t("appointments.sub_title")}</p>
                </Col>
                <Col md={4} className="exado-col1">
                    <Buttton.Buttton
                        children={t("add_appointment")}
                        className="btn-solid-Aqua_Teal"
                        onClick={() => setShowModal1(true)}
                    />
                </Col>
                <Col md={12}>
                    <Tabbles.TableBlk
                        headerIcon={<PiCalendar className="header-Icn" />}
                        heading={t("appointments.upcoming.page-heading")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/appointment-upcoming/my-appointments"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all_appointments")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("patient_name")}`,
                            `${t("clinics_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("patient_details")}`,
                            `${t("time_&_date")}`,
                            `${t("location")}`,
                            `${t("consult")}`,
                            `${t("take_call")}`,
                            `${t("decline")}`,
                        ]}
                        data={getAppointmentsData?.result?.patientAppointments
                            ?.filter((appointment) => appointment.iAppointmentStatus === 2)
                            ?.map((appointment) => ({
                                [t("patient_name")]: (
                                    <div className="d-flex align-items-center">
                                        <Badges.Badge1
                                            text={appointment.externalUser ? "G" : "E"}
                                            className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
                                                }`}
                                        />{" "}
                                        {appointment.patientFirstName +
                                            " " +
                                            appointment.patientLastName}
                                    </div>
                                ),
                                [t("clinics_name")]: appointment.clinicName,
                                [t("medical_specialty")]: appointment.physicianServices,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <PiFolderOpen
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(appointment, true, false, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("time_&_date")]: (
                                    <>
                                        <div>
                                            {new Date(
                                                appointment.appointmentDateTime
                                            ).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </div>
                                        <div>
                                            {new Date(appointment.appointmentDateTime)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, " - ")}
                                        </div>
                                    </>
                                ),
                                [t("location")]: appointment.appointmentType,
                                [t("consult")]: (
                                    <Badges.Badge1
                                        text={t("consult")}
                                        className="consult-badge"
                                        onClick={() =>
                                            navigate(`/doctor/diagnostic-report/diagnostic-report`, {
                                                state: {
                                                    appointment,
                                                    appointmentStatus: 2,
                                                },
                                            })
                                        }
                                    />
                                ),
                                ...(appointment.appointmentStatus === "Approved" &&
                                    appointment.appointmentType === "Online"
                                    ? {
                                        [t("take_call")]: (
                                            <div className="editBlkIcon">
                                                <FiPhoneCall
                                                    className="editIcon"
                                                // onClick={() => handleVideoCall(appointment)}
                                                />
                                            </div>
                                        ),
                                    }
                                    : {
                                        [t("take_call")]: "-",
                                    }),
                                [t("decline")]: (
                                    <PiTrash
                                        className="delIcon noVerify"
                                        onClick={() => {
                                            postBookedAppointment(appointment, false, false, false);
                                            setShowModal3(true);
                                            setSelectedAppointmentGuid(appointment.appointmentGuid);
                                        }}
                                    />
                                ),

                            }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_pending_verification")}
                    />
                </Col>
                <Col className="exado-col2" md={12}>
                    <Tabbles.TableBlk
                        headerIcon={<PiCalendar className="header-Icn" />}
                        heading={t("doctor.dashboard.clinics_upcoming_appointments")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to={`/doctor/appointment-upcoming/clinic-appointments`}
                                className="exado_body_text dash-link"
                            >
                                {t("see_all_appointments")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("patient_name")}`,
                            `${t("doctor_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("patient_details")}`,
                            `${t("time_&_date")}`,
                            `${t("location")}`,
                            `${t("consult")}`,
                            `${t("decline")}`,
                        ]}
                        data={getClinicUpcomingAppointmentsData?.result?.patientAppointments
                            ?.filter((appointment) => appointment.iAppointmentStatus === 2)
                            ?.map((appointment) => ({
                                [t("patient_name")]: (
                                    <div className="d-flex align-items-center">
                                        <Badges.Badge1
                                            text={appointment.externalUser ? "G" : "E"}
                                            className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
                                                }`}
                                        />{" "}
                                        {appointment.patientFirstName +
                                            " " +
                                            appointment.patientLastName}
                                    </div>
                                ),
                                [t("doctor_name")]:
                                    appointment.doctorFirstName +
                                    " " +
                                    appointment.doctorLastName,
                                [t("medical_specialty")]: appointment.physicianServices,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <PiFolderOpen
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(appointment, true, false, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("time_&_date")]: (
                                    <>
                                        <div>
                                            {new Date(
                                                appointment.appointmentDateTime
                                            ).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </div>
                                        <div>
                                            {new Date(appointment.appointmentDateTime)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, " - ")}
                                        </div>
                                    </>
                                ),
                                [t("location")]: appointment.appointmentType,
                                [t("consult")]: (
                                    <Badges.Badge1
                                        text="CONSULT"
                                        className="consult-badge"
                                        onClick={() =>
                                            navigate(`/doctor/diagnostic-report/diagnostic-report`, {
                                                state: {
                                                    appointment,
                                                    appointmentStatus: 2,
                                                },
                                            })
                                        }
                                    />
                                ),
                                [t("decline")]: (
                                    <PiTrash
                                        className="delIcon noVerify"
                                        onClick={() => {
                                            postBookedAppointment(appointment, false, false, false);
                                            setShowModal3(true);
                                            setSelectedAppointmentGuid(appointment.appointmentGuid);
                                        }}
                                    />
                                ),
                            }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_pending_verification")}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col md={8}>
                    <h2 className="exado-title-nine">{t("appointment_requests")}</h2>
                    <p className="exado-title-three ">
                        {t("doctor.dashboard.appointment_request_info")}
                    </p>
                </Col>
                <Col md={12}>
                    <Tabbles.TableBlk
                        headerIcon={<PiCalendar className="header-Icn" />}
                        heading={t("appointments.requested.page-heading")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/appointment-request/my-appointments"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all_appointments")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("patient_name")}`,
                            `${t("booking_id")}`,
                            `${t("clinics_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("patient_details")}`,
                            `${t("time_&_date")}`,
                            `${t("location")}`,
                            `${t("accept")}`,
                            `${t("decline")}`,
                        ]}
                        data={getRequestedAppointmentsData?.result?.patientAppointments.map(
                            (appointment) => ({
                                [t("patient_name")]: (
                                    <div className="d-flex align-items-center">
                                        <Badges.Badge1
                                            text={appointment.externalUser ? "G" : "E"}
                                            className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
                                                }`}
                                        />{" "}
                                        {appointment.patientFirstName +
                                            " " +
                                            appointment.patientLastName}
                                    </div>
                                ),
                                [t("booking_id")]: appointment.bookingId,
                                [t("clinics_name")]: appointment.clinicName,
                                [t("medical_specialty")]: appointment.physicianServices,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <PiFolderOpen
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(appointment, true, false, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("time_&_date")]: (
                                    <>
                                        <div>
                                            {new Date(
                                                appointment.appointmentDateTime
                                            ).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </div>
                                        <div>
                                            {new Date(appointment.appointmentDateTime)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, " - ")}
                                        </div>
                                    </>
                                ),
                                [t("location")]: appointment.appointmentType,
                                [t("accept")]: (
                                    <div className="editBlkIcon">
                                        <PiThumbsUp
                                            className="editIcon"
                                            onClick={() => handleAcceptReject(appointment, true)}
                                        />
                                    </div>
                                ),
                                [t("decline")]: (
                                    <PiTrash
                                        className="delIcon noVerify"
                                        onClick={() => handleAcceptReject(appointment, false)}
                                    />
                                ),
                            })
                        )}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_pending_verification")}
                    />
                </Col>
                <Col className="exado-col2">
                    <Tabbles.TableBlk
                        headerIcon={<PiCalendar className="header-Icn" />}
                        heading={t("doctor.dashboard.clinics_requested_appointments")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/appointment-request/clinic-appointments"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all_appointments")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("patient_name")}`,
                            `${t("booking_id")}`,
                            `${t("doctor_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("patient_details")}`,
                            `${t("time_&_date")}`,
                            `${t("location")}`,
                            `${t("accept")}`,
                            `${t("decline")}`,
                        ]}
                        data={getClinicRequestedAppointmentsData?.result?.patientAppointments.map(
                            (appointment) => ({
                                [t("patient_name")]: (
                                    <div className="d-flex align-items-center">
                                        <Badges.Badge1
                                            text={appointment.externalUser ? "G" : "E"}
                                            className={`ge-badge ${appointment.externalUser ? "g-badge" : "e-badge"
                                                }`}
                                        />{" "}
                                        {appointment.patientFirstName +
                                            " " +
                                            appointment.patientLastName}
                                    </div>
                                ),
                                [t("booking_id")]: appointment.bookingId,
                                [t("doctor_name")]:
                                    appointment.doctorFirstName +
                                    " " +
                                    appointment.doctorLastName,
                                [t("medical_specialty")]: appointment.physicianServices,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <PiFolderOpen
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(appointment, true, false, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("time_&_date")]: (
                                    <>
                                        <div>
                                            {new Date(
                                                appointment.appointmentDateTime
                                            ).toLocaleTimeString("en-US", {
                                                hour: "2-digit",
                                                minute: "2-digit",
                                                hour12: true,
                                            })}
                                        </div>
                                        <div>
                                            {new Date(appointment.appointmentDateTime)
                                                .toLocaleDateString("en-GB")
                                                .replace(/\//g, " - ")}
                                        </div>
                                    </>
                                ),
                                [t("location")]: appointment.appointmentType,
                                [t("accept")]: (
                                    <div className="editBlkIcon">
                                        <PiThumbsUp
                                            className="editIcon"
                                        // onClick={() => handleRequest(request, 2)}
                                        />
                                    </div>
                                ),
                                [t("decline")]: (
                                    <PiTrash
                                        className="delIcon noVerify"
                                    // onClick={() => handleRequest(request, 3)}
                                    />
                                ),
                            })
                        )}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_pending_verification")}
                    />
                </Col>
            </Row>
            <Row className="exado-row1">
                <Col md={12}>
                    <h2 className="exado-title-nine">{t("Chats")}</h2>
                    <p className="exado-title-three ">
                        {t("doctor.dashboard.chat_request_info")}
                    </p>
                </Col>
                <Col lg={6}>
                    <Tabbles.TableBlk
                        headerIcon={<LuMessagesSquare className="header-Icn" />}
                        heading={t("doctor.dashboard.upcoming_chats")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/chat-requested"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("patient_name")}`,
                            `${t("patient_details")}`,
                            `${t("doctor_name")}`,
                            `${t("start_chat")}`,
                        ]}
                        data={getChatAppointmentByDoctorData?.result
                            ?.filter((item) => item.status === 1)
                            ?.slice(0, 1)
                            ?.map((chat) => ({
                                [t("patient_name")]: chat.patientName,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <LuFileSearch2
                                            className="editIcon"
                                            onClick={() => setShowModal4(true)}
                                        />
                                    </div>
                                ),
                                [t("doctor_name")]: chat.doctorName,
                                [t("start_chat")]: (
                                    <div className="editBlkIcon">
                                        <PiThumbsUp
                                            className="editIcon"
                                            onClick={() => {
                                                const credentials1 = {
                                                    appointmentGuid: chat.appointmentGuid,
                                                    DoctorGuid: chat.doctorGuid,
                                                    Status: 2,
                                                    IsChatAccepted: true,
                                                    PatientGuid: chat.patientGuid,
                                                    ContinueChatStatus: 1,
                                                };

                                                dispatch(
                                                    actionDoctor.postUpdateChatAppointment(
                                                        credentials1,
                                                        (error, response) => {
                                                            if (error) {
                                                                if (error.data) {
                                                                    if (error.data.statusCode === 400) {
                                                                        if (
                                                                            error.data.error &&
                                                                            error.data.error.ValidationErrors
                                                                        ) {
                                                                            error.data.error.ValidationErrors.forEach(
                                                                                (validationError) => {
                                                                                    console.error(
                                                                                        `${t("Field")}: ${validationError.Field
                                                                                        } - ${t("Message")}: ${validationError.Message
                                                                                        }`
                                                                                    );
                                                                                    showAlert(
                                                                                        "danger",
                                                                                        validationError.Message,
                                                                                        `${t("Error")} : ${validationError.Field
                                                                                        }`
                                                                                    );
                                                                                }
                                                                            );
                                                                        } else {
                                                                            if (error.data.message) {
                                                                                showAlert(
                                                                                    "danger",
                                                                                    error.data.message,
                                                                                    `${t("Error")} !`
                                                                                );
                                                                            } else {
                                                                                showAlert(
                                                                                    "danger",
                                                                                    `${t("Invalid_credentials")}`,
                                                                                    `${t("Error")} !`
                                                                                );
                                                                            }
                                                                        }
                                                                    } else {
                                                                        showAlert(
                                                                            "danger",
                                                                            `${t("unexpected_error")} ${t("Error")} !`
                                                                        );
                                                                    }
                                                                }
                                                            } else if (response) {
                                                                if (response.status === 200) {
                                                                    showAlert(
                                                                        "secondary",
                                                                        t("chat_started_successfully"),
                                                                        "Info !"
                                                                    );
                                                                    navigate(
                                                                        `/doctor/chat-with-patient/${chat?.appointmentGuid}`,
                                                                        {
                                                                            state: { chat },
                                                                        }
                                                                    );
                                                                }
                                                            }
                                                        }
                                                    )
                                                );
                                            }}
                                        />
                                    </div>
                                ),
                            }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_upcoming_chats")}
                    />
                </Col>
                <Col lg={6} className="dash-col">
                    <Tabbles.TableBlk
                        headerIcon={<LuMessagesSquare className="header-Icn" />}
                        heading={t("chatPage.onGoing.pageHeading")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/chat-ongoing"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("patient_name")}`,
                            `${t("patient_details")}`,
                            `${t("doctor_name")}`,
                            `${t("respond")}`,
                        ]}
                        data={getChatAppointmentByDoctorData?.result
                            ?.filter((item) => item.status === 2)
                            ?.slice(0, 1)
                            ?.map((chat) => ({
                                [t("patient_name")]: chat.patientName,
                                [t("patient_details")]: (
                                    <div className="editBlkIcon">
                                        <LuFileSearch2
                                            className="editIcon"
                                            onClick={() =>
                                                postBookedAppointment(chat, true, true, false)
                                            }
                                        />
                                    </div>
                                ),
                                [t("doctor_name")]: chat.doctorName,
                                [t("respond")]: (
                                    <div className="editBlkIcon">
                                        <LuMessagesSquare
                                            className="editIcon"
                                            onClick={() =>
                                                navigate(
                                                    `/doctor/chat-with-patient/${chat?.appointmentGuid}`,
                                                    { state: { chat } }
                                                )
                                            }
                                        />
                                    </div>
                                ),
                            }))}
                        tabbleClassname="tabble"
                        noDataMessage={t("doctor.dashboard.no_ongoing_chats")}
                    />
                </Col>
            </Row>
            <Row className="exado-row1 dash-row">
                <Col md={12}>
                    <h2 className="exado-title-nine">
                        {t("doctor.dashboard.emergency_consultation")}
                    </h2>
                    <p className="exado-title-three ">
                        {t("doctor.dashboard.emergency_consultation_description")}
                    </p>
                </Col>
                <Col>
                    <Tabbles.TableBlk
                        headerIcon={<HiOutlinePhoneMissedCall className="header-Icn" />}
                        heading={t("doctor.dashboard.emergency_consultation")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link
                                to="/doctor/emergency-calls"
                                className="exado_body_text dash-link"
                            >
                                {t("see_all")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("booking_id")}`,
                            `${t("doctor_name")}`,
                            `${t("patient_name")}`,
                            `${t("medical_specialty")}`,
                            `${t("time")}`,
                            `${t("patient_details")}`,
                            `${t("take_call")}`,
                        ]}
                        data={filteredCalls?.map((call, index) => ({
                            [t("booking_id")]: call.bookingId,
                            [t("doctor_name")]: call.doctorName,
                            [t("patient_name")]: call.patientName,
                            [t("medical_specialty")]: call.medicalSpeciality,
                            [t("time")]: (
                                <Commons.CountdownTimer
                                    appointmentDateTime={call.appointmentDateTime}
                                    timerMinutes={call.timerMinutes}
                                    onTimeout={() => {
                                        dispatch(
                                            actionDoctor.getEmergencyCallByDoctor(credentials)
                                        );
                                    }}
                                />
                            ),
                            [t("patient_details")]: (
                                <div className="editBlkIcon">
                                    <LuFileSearch2
                                        className="editIcon"

                                        onClick={() => postBookedAppointment(call, true, false, true)}
                                    />
                                </div>
                            ),
                            [t("take_call")]: (
                                <div className="editBlkIcon">
                                    <FiPhoneCall
                                        className="editIcon"
                                        onClick={() => handleVideoCall(call)}
                                    />
                                </div>
                            ),
                        }))}
                        tabbleClassname="tabble"
                        noDataMessage={t(
                            "doctor.dashboard.no_pending_clinic_verifications"
                        )}
                    />
                </Col>
            </Row>
            <Row className="exado-row1 dash-row">
                <Col md={12}>
                    <h2 className="exado-title-nine">
                        {t("doctor.dashboard.clinic_verification_request")}
                    </h2>
                    <p className="exado-title-three ">
                        {t("doctor.dashboard.placeholder_text")}
                    </p>
                </Col>
                <Col>
                    <Tabbles.TableBlk
                        headerIcon={<PiStethoscope className="header-Icn" />}
                        heading={t("doctor.dashboard.clinics_verification_requests")}
                        subHeading={
                            <span>
                                {t("Today")}, {formattedDate}
                            </span>
                        }
                        thrside={
                            <Link to="" className="exado_body_text dash-link">
                                {t("see_all_appointments")} <FaCaretRight />
                            </Link>
                        }
                        columns={[
                            `${t("no")}`,
                            `${t("clinics_name")}`,
                            `${t("phone_number")}`,
                            `${t("email")} ${t("Address")}`,
                            `${t("Address")}`,
                            `${t("accept")}`,
                            `${t("decline")}`,
                        ]}
                        data={chatRequest?.map((request, index) => ({
                            [t("no")]: index + 1,
                            [t("clinics_name")]: request.clinicName,
                            [t("phone_number")]: request.mobile,
                            [`${t("email")} ${t("Address")}`]: request.email,
                            [t("Address")]: request.adress,
                            [t("accept")]: (
                                <div className="editBlkIcon">
                                    <PiThumbsUp
                                        className="editIcon"
                                        onClick={() => handleRequest(request, 2)}
                                    />
                                </div>
                            ),
                            [t("decline")]: (
                                <PiTrash
                                    className="delIcon noVerify"
                                    onClick={() => handleRequest(request, 3)}
                                />
                            ),
                        }))}
                        tabbleClassname="tabble"
                        noDataMessage={t(
                            "doctor.dashboard.no_pending_clinic_verifications"
                        )}
                    />
                </Col>
            </Row>
        </>
    );

    return (
        <>
            <DashboardCommonPage
                loginData={loginData}
                overView={overView}
                rightSide1={rightSide1}
                userType={Commons.userType.doctor}
            />

            <Modaal.AddAppointmentModal
                loginData={loginData}
                show={showModal1}
                onHide={handleCloseModal}
                centered="true"
                size="xl"
                backdrop="static"
            />
            <Modaal.PatientDetailsModal
                show={showModal2}
                onHide={() => setShowModal2(false)}
                loginData={loginData}
                setShowModal3={setShowModal3}
                setShowModal2={setShowModal2}
                setSelectedAppointmentGuid={setSelectedAppointmentGuid}
            />
            <Modaal.PatientDetailsModal
                show={showModal4}
                onHide={() => setShowModal4(false)}
                loginData={loginData}
                // setSelectedAppointmentGuid={setSelectedAppointmentGuid}
                chatAppointmentDetails={true}
            />
            <Modaal.PatientDetailsModal
                show={showModal5}
                onHide={() => setShowModal5(false)}
                loginData={loginData}
                // setSelectedAppointmentGuid={setSelectedAppointmentGuid}
                emergencyCall={true}
            />

            <Modaal.CancelAppointmentModal
                show={showModal3}
                onHide={() => setShowModal3(false)}
                loginData={loginData}
                appointmentGuid={selectedAppointmentGuid}
                setSelectedAppointmentGuid={setSelectedAppointmentGuid}
                dashboard={true}
            />
        </>
    );
};

export default Dashboard;
